import { useEffect } from "react";

const useUrlChange = (callback: (url: string) => void) => {
  useEffect(() => {
    const handler = (e: Event) => {
      const { url } = (e as CustomEvent<{ url: string }>).detail;
      callback(url);
    };

    document.addEventListener("sd-url-change", handler);

    return () => {
      document.removeEventListener("sd-url-change", handler);
    };
  }, []);
};

export default useUrlChange;
